<template>
  <div class="main-view">
    <el-radio-group v-model="table.params.status" @change="onSearch" class="status-tabs">
      <el-radio-button :label="1">合作中</el-radio-button>
      <el-radio-button :label="2">已禁用</el-radio-button>
    </el-radio-group>
    
    <div class="section shadow filter__wrap">
      <el-form ref="elFormDom" inline :model="table.params" :size="subUnitSize">
        <el-form-item label="供应商" prop="keyword">
          <el-input
            size="mini"
            v-model.trim="table.params.keyword"
            placeholder="名称/联系人/联系方式"
            clearable
            @keydown.enter.native="onSearch"
          ></el-input>
        </el-form-item>
        <!-- 不是地区账号加地区查询条件 -->
        <el-form-item label="地区" prop="area" v-if="!city && !province">
          <el-cascader
            v-model="table.params.area"
            :options="areaArr"
            :props="{ checkStrictly: true }"
            clearable
            filterable
            style="width: 100%"
            @change="onSearch"
          >
          </el-cascader>
        </el-form-item>
        <el-form-item label="供货类别" prop="order_cate_id">
          <el-select v-model="table.params.order_cate_id" placeholder="请选择" clearable filterable style="width: 100%" @change="onSearch">
            <el-option
              v-for="item in orderCateArr"
              :label="item.name"
              :value="item.id"
              :key="item.id"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="对接人" prop="contact_id">
          <el-select v-model="table.params.contact_id" placeholder="请选择" clearable filterable style="width: 100%" @change="onSearch">
            <el-option
              v-for="item in purchasePersonOpt"
              :label="item.name"
              :value="item.id"
              :key="item.id"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="采买方式" prop="buy_type">
          <el-select v-model="table.params.buy_type" placeholder="请选择" clearable filterable style="width: 100%" @change="onSearch">
            <el-option
              label="现金采买"
              :value="1"
            ></el-option>
            <el-option
              label="非现金采买"
              :value="2"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" icon="el-icon-search" @click="onSearch"
            >搜索</el-button
          >
          <el-button icon="el-icon-refresh-right" @click="reset"
            >重置</el-button
          >
        </el-form-item>
      </el-form>
      <div class="btnAdd">
        <el-button
          :size="subUnitSize"
          type="primary"
          icon="el-icon-plus"
          @click="showEdit"
          >创建</el-button
        >
        <el-button
          :size="subUnitSize"
          type="primary"
          @click="exportData('/admin/supplier/export')"
          >导出</el-button
        >
      </div>
    </div>

    <VTable
      has-pagionation
      :field="field"
      :loading="table.loading"
      :data="table.data"
      :page="table.params.page"
      :pageSize="table.params.count"
      :total="table.total"
      :tree-props="{ children: 'children', hasChildren: 'has_child' }"
      :hasPagionation="true"
      :default-expand-all="true"
      :showSelect="true"
      @handleSelectionChange="handleSelectionChange"
      @handleSizeChange="handleSizeChange"
      @handleCurrentChange="handleCurrentChange"
    >
      <template v-slot:contact_user="{ row }">
        <span>{{row.contact_user}}{{row.contact_two_user?`,${row.contact_two_user}`:''}}</span>
      </template>
      <template v-slot:buy_type="{ row }">
        <span>{{row.buy_type == 1?'现金采买':row.buy_type == 2?'非现金采买':''}}</span>
      </template>
      <template v-slot:province_str="{ row }">
        <span>{{ row.province_str }}{{ row.city_str }}</span>
      </template>
      <template v-slot:merchant_name="{ row }">
        <template v-if="!!row.merchant_name && row.merchant_name.length > 0">
          <div v-for="(v, i) in row.merchant_name" :key="i">
            <span v-if="!!v">{{ v }}</span>
            <span v-if="i < row.merchant_name.length - 1">，</span>
          </div>
        </template>
        <span v-else></span>
      </template>
      <template v-slot:goods_count="{ row }">
        <el-link
          style="padding: 0 10px"
          type="primary"
          @click="selGoods(row)"
          >{{ row.goods_count }}</el-link
        >
      </template>
      <template v-slot:status="{ row }">
        <span :style="{ color: `${row.status == 1 ? '' : '#f56c6c'}` }">{{
          row.status == 1 ? "启用" : "禁用"
        }}</span>
      </template>
      <template v-slot:is_sorter="{ row }">
        <span>{{ row.is_sorter == 1 ? "是" : "否" }}</span>
        <div v-if="row.show_num == 1" style="font-size:11px">录单数取订单数</div>
      </template>
      <template v-slot:create_name="{ row }">
        <div>{{ row.create_name }}</div>
        <div style="font-size:12px">{{ row.create_time }}</div>
      </template>
      <!-- 评分 -->
      <template v-slot:score="{ row }">
        <el-rate v-model="row.score" disabled text-color="#ff9900"> </el-rate>
      </template>
      <template v-slot:is_send="{ row }">
        <el-switch
          v-model="row.is_send"
          :active-value="1"
          :inactive-value="2"
          :active-text="`已${row.is_send == 1 ? '开启' : '关闭'}`"
          @change="handleSend(row)"
        >
        </el-switch>
      </template>
      <template v-slot:action="{ row }">
        <el-button type="text" @click="showEdit(row)">编辑</el-button>
        <el-button type="text" @click="handleOperate(row)">{{
          row.status == 1 ? "禁用" : "启用"
        }}</el-button>
        <el-button type="text" @click="remove(row)" v-if="is_sys == 1">删除</el-button>
      </template>
    </VTable>

    <!-- 编辑 -->
    <edit ref="edit" @refresh="getTable"></edit>

    <!-- 绑定供货商品 -->
    <SelGoods
      :dialogTitle="dialogTitle"
      ref="selGoods"
      :getDataApi="getDataApi"
      :setDataApi="setDataApi"
      :showBind="showBind"
      :sourceType="sourceType"
      @refresh="getTable"
    >
    </SelGoods>
  </div>
</template>

<script>
import Edit from "./components/Edit.vue";
import SelGoods from "@/components/SelGoods.vue";
import VTable from "@/components/VTable";
import { mixinTable } from "@/mixins/table.js";
import { mapGetters } from "vuex";
import { getStorage } from "@/storage";

export default {
  name: "SupplierIndex",
  components: {
    Edit,
    SelGoods,
    VTable,
  },
  mixins: [mixinTable],
  computed: {
    ...mapGetters(["areaArr"]),
  },
  data() {
    return {
      province: getStorage('province'),  // 有地区就是区账号
      city: getStorage('city'),  // 有地区就是区账号
      subUnitSize: this.$store.state.subUnitSize, // 获取组件 size属性
      getDataApi: "/admin/supplier/goodsList",
      setDataApi: "/admin/supplier/patch",
      showBind: true,
      sourceType: 1, // 供应商
      field: [
        { name: "id", label: "ID", width: "80", hidden: false },
        { name: "name", label: "供应商名称", hidden: false },
        { name: "contact", label: "联系人", hidden: false },
        { name: "contact_phone", label: "联系方式", hidden: false },
        // { name: "account", label: "登录账号", hidden: false },
        { name: "license_no", label: "营业执照名称", hidden: false },
        { name: "province_str", label: "所在地区", hidden: false },
        {
          name: "merchant_name",
          label: "供应客户",
          width: "150",
          hidden: false,
        },
        { name: "goods_count", label: "商品数量", width: "80", hidden: false },
        { name: "order_cate_name", label: "供货类别", width: "80", hidden: false },
        { name: "is_sorter", label: "提供代分拣", width: "100", hidden: false },
        // { name: "score", label: "综合评分", width: "150", hidden: false },
        // { name: "status", label: "状态", hidden: false },
        { name: "contact_user", label: "对接人", hidden: false },
        { name: "buy_type", label: "采买方式", hidden: false },
        { name: "is_send", label: "短信通知", width: "120", hidden: false },
        { name: "create_name", label: "创建人", width: "130", hidden: false },
        {
          name: "action",
          label: "操作",
          width: "160",
          fixed: "right",
          hidden: false,
        },
      ],
      table: {
        loading: false,
        params: {
          keyword: "",
          status: 1,
          area: [],
          province: "",
          city: "",
          order_cate_id: "",
          contact_id: "",
          buy_type:'',
          page: 1,
          count: 10,
        },
        data: [],
        total: 0,
      },
      dialogTitle: "负责供货商品",
      message: false,
      selectList:[],
      orderCateArr: [], // 供货类别
      purchasePersonOpt: [], // 采购员
    };
  },
  created() {
    this.getTable();
    this.getOrderCateSel(); // 获取供货类别
    this.getPurchasePerson();
  },
  methods: {
    // 获取供货类别
    getOrderCateSel() {
      this.$http.get('/admin/mini_cate/list', {params:{page:1,count:1000}}).then(res => {
        if(res.code === 1) {
          this.orderCateArr = res.data.list.map(obj => ({ ...obj })).reduce((acc, obj) => {
            if (obj.child.length == 0) {
              delete obj.child; // 删掉空的二级分类child
              acc.push(obj);
            } else {
              acc.push(obj);
            }
            return acc;
          }, []);
        }
      })
    },
    getTable() {
      let _area = this.table.params.area;
      if (_area.length == 1) {
        this.table.params.province = _area[0];
      } else if (_area.length == 2) {
        this.table.params.province = _area[0];
        this.table.params.city = _area[1];
      } else {
        this.table.params.province = "";
        this.table.params.city = "";
      }
      this.table.loading = true;
      this.$http
        .get("/admin/supplier/list", { params: this.table.params })
        .then((res) => {
          if (res.code === 1) {
            this.table.loading = false;
            this.table.data = res.data.list.map((item) => {
              return {
                ...item,
                score: Number(item.score),
              };
            });
            this.table.total = res.data.total;
          }
        });
    },
    // 新增、编辑
    showEdit(row) {
      let dom = this.$refs.edit;
      dom.toggle(true);
      dom.getDetail(row);
      dom = null;
    },
    //负者供货商品
    selGoods(row) {
      let dom = this.$refs.selGoods;
      dom.toggle(true);
      dom.getDetail(row);
      dom = null;
    },
    // 禁用
    handleOperate(row) {
      this.setConfirm(
        `确认禁用操作？`,
        { id: row.id },
        "/admin/supplier/operation"
      );
    },
    // 删除
    remove(row) {
      this.setConfirm(
        `确认删除操作？`,
        { id: row.id },
        "/admin/supplier/delete"
      );
    },
    // 短信通知
    handleSend(row) {
      this.$http
        .post("/admin/supplier/open", { id: row.id })
        .then((res) => {
          if (res.code == 1) {
            this.$message.success(
              `短信${row.is_send == 1 ? "开启" : "关闭"}成功！`
            );
          } else {
            this.$message.error(res.msg);
          }
        })
        .finally(() => {
          this.getTable();
        });
    },
    handleSelectionChange(val){
      this.selectList = val;
    },
    exportData(url) {
      let str = '';
      let obj  = {
        keyword:this.table.params.keyword,
        status:this.table.params.status,
        province:this.table.params.province,
        city:this.table.params.city,
      };
      let ids = this.selectList.map(item => item.id).join(',');
      obj.ids = ids;
      Object.keys(obj).forEach(item => {
        str += `&${item}=${obj[item]}`
      });
      console.log(`${process.env.VUE_APP_BASE_API}${url}?token=${this.token}${str}`)
      window.open(`${process.env.VUE_APP_BASE_API}${url}?token=${this.token}${str}`)
    }
  },
};
</script>

<style lang="scss" scoped>
.status-tabs {
  margin-bottom: 15px;
}
</style>
